const isMobile = (): boolean => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const ios = /iphone|ipod|ipad/.test(userAgent);
    const iPad13 = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    const android = /android/.test(userAgent);
    return ios || iPad13 || android;
  };
  export default isMobile;